import { action, computed, observable } from 'mobx';
import { IAutomationSidebarConfig } from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/automation-sidebar.types';
import {
    IAutomationStepActionPipeline,
    TAutomationStepBlockErrorMessageKeys
} from '~/types/automation.types';
import PipelineStagesSideBar from '~/components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/PipelineStagesSideBar';
import { AutomationStepActionBase } from '~/models/automations-steps/automations-step-actions/automation-step-action-base';
import AutomationBlockActionPipelineStage from '~/components/Automations/AutomationsBuilder/AutomationsBuilderCanvas/AutomationBlockElements/AutomationBlockActionPipelineStage';
import { NAMESPACES } from '~/i18n/namespaces';
import { getFixedT } from 'i18next';

export class AutomationStepActionPipeline
    extends AutomationStepActionBase
    implements IAutomationStepActionPipeline
{
    @observable type: 'pipeline';
    @observable pipeline_stage_id: string;
    @observable pipeline_stage_name: string;
    t = getFixedT(null, NAMESPACES.PIPELINE, 'customize');

    @computed
    get title() {
        return this.pipeline_stage_name
            ? this.t(
                  `fixed_names.${this.pipeline_stage_name}`.toString() ||
                      'Select stage',
                  this.pipeline_stage_name
              ).toUpperCase()
            : 'Select stage';
    }

    get errorMessageKey(): TAutomationStepBlockErrorMessageKeys {
        return 'missing_pipeline_stage';
    }

    @computed
    get isValid() {
        return !!this.pipeline_stage_id;
    }

    @computed
    get isCompleted() {
        return !!this.pipeline_stage_id;
    }

    @computed
    get stage() {
        return this.pipeline_stage_id;
    }

    @action
    updatePipelineStage(pipelineStage) {
        this.pipeline_stage_name = pipelineStage.name;
        this.pipeline_stage_id = pipelineStage._id;
    }

    getSideBarConfig(): IAutomationSidebarConfig {
        return {
            initialScreen: 'main',
            main: {
                headerProps: { title: 'Action' },
                component: PipelineStagesSideBar,
                parent: null
            }
        };
    }

    get AutomationBlockAction() {
        return AutomationBlockActionPipelineStage;
    }
}
